import { GalleryImage } from "../components/Gallery";
import project1 from "./../assets/referenzseite/4.jpeg";
import project2 from "./../assets/referenzseite/5.jpeg";
import project3 from "./../assets/referenzseite/6.jpeg";
import project4 from "./../assets/referenzseite/7.jpeg";
import project5 from "./../assets/referenzseite/8.jpeg";
import project6 from "./../assets/referenzseite/19.jpeg";
import project7 from "./../assets/referenzseite/21.jpeg";
import project8 from "./../assets/referenzseite/23.jpeg";
import project9 from "./../assets/referenzseite/18.png";
import project10 from "./../assets/referenzseite/100.jpeg";

export const galleryImages: GalleryImage[] = [
  {
    id: 1,
    src: project1,
    title: "Spielplatzbau & Fallschutzlösungen",
    description:
      "Sichere und langlebige Spielbereiche für Kinder – inklusive Sandkasten, Fallschutz und Bodenarbeiten.",
  },
  {
    id: 2,
    src: project2,
    title: "Gabionenzäune – Stilvoller Sicht- und Lärmschutz",
    description:
      "Hochwertige Gabionenzäune für Privat- und Gewerbeimmobilien – langlebig, modern und funktional.",
  },
  {
    id: 3,
    src: project3,
    title: "Professionelle Gartenpflege mit modernen Maschinen",
    description:
      "Effiziente Pflege und Gestaltung von Grünflächen mit leistungsstarken Maschinen und Fachkompetenz.",
  },
  {
    id: 4,
    src: project4,
    title: "Individuelle Sichtschutzlösungen für Gärten & Höfe",
    description:
      "Moderne und robuste Zäune für mehr Privatsphäre und eine ansprechende Gartengestaltung.",
  },
  {
    id: 5,
    src: project5,
    title: "Gartenteiche & Wasserelemente nach Maß",
    description:
      "Stilvolle Wassergestaltung mit Gabionenteichen – ein echter Hingucker für Ihren Garten.",
  },
  {
    id: 6,
    src: project6,
    title: "Beet- & Pflanzarbeiten für eine grüne Oase",
    description:
      "Neuanlagen und Pflege von Beeten – für ein gepflegtes und ansprechendes Gartenbild.",
  },
  {
    id: 7,
    src: project7,
    title: "Terrassenbau – Stilvoll & Langlebig",
    description:
      "Hochwertige Terrassen für entspannte Stunden im Freien – modern, robust und individuell.",
  },
  {
    id: 8,
    src: project8,
    title: "Terrassensanierung mit Granitplatten",
    description:
      "Neue Optik und mehr Stabilität für Ihre Terrasse – hochwertiger Naturstein für eine edle Gestaltung.",
  },
  {
    id: 9,
    src: project9,
    title: "Gartenpflege mit modernen Maschinen",
    description:
      "Effiziente Pflege und Gestaltung von Grünflächen mit leistungsstarken Maschinen und Fachkompetenz.",
  },
  {
    id: 10,
    src: project10,
    title: "Reinigung von Gittersteinen",
    description:
      "Fachgerechte Säuberung und Pflege von Gittersteinen für eine saubere und gepflegte Oberfläche.",
  },
];
